<template>
	<div class="product">
		<search-apk
			v-on:addApk="addApk"
			v-on:lookLose="lookLose"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-apk>
		<add-apk
			:dialogApk="dialogApk"
			v-on:cancel="cancel"
			:appVersion="appVersion"
		>
		</add-apk>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="appVersionList.records"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="name"
					:label="$t('appVersion.appName')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					:label="$t('appVersion.icon')"
					width="100"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-image
							style="width: 60px;height: 60px"
							:src="scope.row.img"
							fit="fill"
						></el-image>
					</template>
				</el-table-column>
				<el-table-column
					prop="prefix"
					:label="$t('appVersion.appVersionBefore')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="version"
					:label="$t('appVersion.appVersion')"
					width="110"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="fileName"
					:show-overflow-tooltip="true"
					:label="$t('upgrade.fileName')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="vmc"
					width="200"
					:label="$t('upgrade.applyVmcVersion')"
					:align="'center'"
				>
					<template #default="scope">
						<el-tag
							style="margin: 2px"
							v-for="item in scope.row.vmc"
							:key="item.id"
							>{{ item.version }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column
					prop="notes"
					:show-overflow-tooltip="true"
					:label="$t('appVersion.notes')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('upgrade.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 280 : 260"
					:align="'center'"
				>
					<template slot-scope="scope">
						<template v-if="!lose">
							<el-button
								style="margin-bottom: 6px;"
								size="mini"
								@click="handlerCopy(scope.row)"
								>{{ $t("upgrade.copyUrl") }}</el-button
							>
							<el-button size="mini" @click="editApk(scope.row)">{{
								$t("common.edit")
							}}</el-button>
							<el-button
								v-if="scope.row.flag != 1"
								size="mini"
								v-hasPerm="['upgrade:apk:admin']"
								@click="handlerChangeFlag(scope.row, -1)"
								>{{ $t("upgrade.setLose") }}</el-button
							>
							<el-button
								v-if="scope.row.flag != 1"
								size="mini"
								v-hasPerm="['upgrade:apk:admin']"
								@click="handlerChangeFlag(scope.row, 1)"
								>{{ $t("upgrade.setNew") }}</el-button
							>
							<el-button
								v-if="scope.row.flag == 1"
								size="mini"
								v-hasPerm="['upgrade:apk:admin']"
								@click="handlerChangeFlag(scope.row, 0)"
								>{{ $t("upgrade.unSetNew") }}</el-button
							>
							<el-button
								v-if="scope.row.flag == 1"
								size="mini"
								v-hasPerm="['upgrade:apk:admin']"
								@click="handlerUp(scope.row)"
								>{{ $t("upgrade.oneKey") }}</el-button
							>
						</template>
						<el-button
							v-else
							size="mini"
							v-hasPerm="['upgrade:apk:admin']"
							@click="handlerChangeFlag(scope.row, 0)"
							>{{ $t("upgrade.unSetLose") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import AddApk from "_c/upgrade/AddApk.vue";
import SearchApk from "_c/upgrade/SearchApk.vue";
export default {
	name: "Apk",
	components: {
		SearchApk,
		AddApk,
	},
	data() {
		return {
			type: "",
			lose: false,
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			search: {
				fileName: "",
				version: "",
				startTime: "",
				endTime: "",
			},
			appVersionList: [],

			dialogApk: false,
			appVersion: {
				id: "",
				vmc: [],
				version: "",
				prefix: "",
				img: "",
				name: "",
				url: "",
				fileName: "",
				firmwareId: "",
				notes: "",
			},
			lock: true,
			searchType: 1,
		};
	},
	mounted() {
		this.type = localStorage.getItem("wType") || "";
		this.currentChange();
	},
	methods: {
		// 复制下载链接
		handlerCopy(row) {
			this.$tools.copy(row.url);
		},
		// 一键检测升级
		handlerUp() {
			let _self = this;
			_self.$confirm("Are you sure?").then(() => {
				if (!_self.lock) {
					_self.$message.warning(
						"Please be patient and wait for the operation after 60s."
					);
					throw "done";
				}
				let obj = { type: _self.type };
				_self.$api
					.request(_self.$url.Upgrade.oneKeyUp, _self.$method.post, obj)
					.then(res => {
						if (res.code === 0) {
							_self.$message.success(res.msg);
							_self.currentChange();
							_self.lock = false;
							let timer = setTimeout(() => {
								_self.lock = true;
								clearTimeout(timer);
							}, 60000);
						}
					});
			});
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			obj.type = this.type;
			obj.searchType = this.searchType;
			if (this.lose) {
				obj.flag = -1;
			} else {
				delete obj.flag;
				obj.searchType = 1;
			}
			this.$api
				.request(this.$url.Upgrade.appList, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.appVersionList = res.data;
						this.page.pageSize = +this.appVersionList.size;
						this.page.totalSize = +this.appVersionList.total;
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},

		addApk() {
			this.dialogApk = true;
		},
		// 更改状态flag
		handlerChangeFlag(item, flag) {
			console.log(111);
			let _self = this;
			_self.$confirm("Are you sure?").then(() => {
				item.flag = flag;
				this.$api
					.request(this.$url.Upgrade.updateFlag, this.$method.put, item)
					.then(res => {
						if (res.code === 0) {
							this.currentChange();
							this.$message.success(res.msg);
						}
					});
			});
		},
		// 查看失效
		lookLose() {
			this.lose = !this.lose;
			if (this.lose) {
				this.searchType = 0;
			} else {
				this.searchType = 1;
			}
			this.currentChange();
		},

		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		cancel(dialog, state) {
			this.dialogApk = dialog;
			if (state) {
				this.currentChange();
			}
		},
		editApk(row) {
			this.dialogApk = true;
			Object.keys(this.appVersion).forEach(key => {
				this.appVersion[key] = row[key];
			});
			console.log(this.appVersion);
		},
	},
};
</script>

<style>
.el-tag--mini {
	margin-right: 5px;
}
</style>
